const prod = {
  backendURL : 'https://api.symbolstones.archaeoptics.co.uk',
  externalStaticURL : 'https://static.archaeoptics.co.uk/symbolstones'
}

const dev = {
  backendURL : 'http://localhost:5013',
  externalStaticURL : 'https://static.archaeoptics.co.uk/symbolstones'
}

const config = process.env.NODE_ENV === 'production'
  ? prod
  : dev

export default {
  ...config
}
